import React from "react";
import { Layout } from "../components/layout";
import { SEO } from "../components/common";

export function PrivacyPolicyPage() {
  return (
    <Layout fullWidth>
      <SEO
        title="Privacy Policy | Block Pattern Generator"
        description="Learn about how we collect, use, and protect your data. Our commitment to privacy and data security for Block Pattern Generator users."
        keywords={[
          "privacy policy",
          "data protection",
          "user privacy",
          "wordpress blocks privacy",
        ]}
      />
      <div className="max-w-4xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold text-white mb-8">Privacy Policy</h1>

        <div className="bg-gray-800/50 rounded-xl p-8">
          <div className="prose prose-invert max-w-none">
            <p className="text-gray-400 italic">
              This is a placeholder for your privacy policy content. Please
              replace this with your actual privacy policy.
            </p>

            <div className="space-y-6 text-gray-300">
              <section>
                <h2 className="text-xl font-semibold text-white">
                  1. Information We Collect
                </h2>
                <p>Placeholder for information collection policies.</p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white">
                  2. How We Use Your Information
                </h2>
                <p>Placeholder for information usage policies.</p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white">
                  3. Information Sharing and Disclosure
                </h2>
                <p>Placeholder for information sharing policies.</p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white">
                  4. Data Security
                </h2>
                <p>Placeholder for data security measures.</p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white">
                  5. Your Rights
                </h2>
                <p>Placeholder for user rights information.</p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white">
                  6. Contact Us
                </h2>
                <p>Placeholder for contact information.</p>
              </section>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
